import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { JobPriceDefiningQuestions, JSONApiDataObject, ReduxEntity } from 'Douleutaras/types';
import { RootState } from 'Douleutaras/redux/store';

const jobPriceDefiningQuestionsAdapter = createEntityAdapter<JSONApiDataObject<JobPriceDefiningQuestions>>();

const jobPriceDefiningQuestionsSlice = createSlice({
  name: 'jobPriceDefiningQuestions',
  initialState: jobPriceDefiningQuestionsAdapter.getInitialState({
    loading: undefined,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<JSONApiDataObject<JobPriceDefiningQuestions>>),
  reducers: {
    jobPriceDefiningQuestionAdded: jobPriceDefiningQuestionsAdapter.setMany
  }
});

export const jobPriceDefiningQuestionsSelector =
  jobPriceDefiningQuestionsAdapter.getSelectors((state: RootState) => state.jobPriceDefiningQuestions);

export default jobPriceDefiningQuestionsSlice;
